import React from 'react';
import PropTypes from 'prop-types';

const TextFieldWithPrependAppend = ({
  source,
  record = {},
  prepend,
  append,
  displayAsLink = false,
  linkTitle = null,
}) => {
  const value = record[source];
  if (value === null || value === undefined) {
    return <span />;
  }

  if (displayAsLink) {
    const url = `${prepend || ''}${value}${append || ''}`;
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {linkTitle || value}
      </a>
    );
  }

  return (
    <span>
      {prepend}
      {value}
      {append}
    </span>
  );
};

TextFieldWithPrependAppend.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  prepend: PropTypes.string,
  append: PropTypes.string,
};

TextFieldWithPrependAppend.defaultProps = {
  prepend: '',
  append: '',
  record: {},
};

export default TextFieldWithPrependAppend;
